module.exports = __webpack_public_path__ + "static/img/contents@w.cf8af86.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-chem-pr-portal/contents@w.png
// module id = VqwL
// module chunks = 0